import { Box, Button } from '@digitools/honest-react';
import { MOBILE_SPOE } from 'src/constants/ScreenSizeConstants';
import styled from 'styled-components';
import BackgroundWave from 'src/assets/background-wave.svg';
export const StyledSpoeButton = styled(Button) `
    border: 2px solid #650030;
    color: #650030;
    border-radius: 20px !important;
    background-color: white;
    padding: 0.75rem 2rem;
    height: 44px;
    max-height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    &, &:hover, &:focus, &:active, &:visited {
        text-decoration: none !important;
    }
    &:not(:disabled):not([aria-disabled='true']):hover {
        background-color: #D0472F;
        color: #FFF;
        border-color: #D0472F;
        text-decoration: none;
    }

    &:not(:disabled):not([aria-disabled='true']):focus,
    &:not(:disabled):not([aria-disabled='true']):focus-visible,
    &:not(:disabled):not([aria-disabled='true']):active {
        background-color: #D0472F;
        color: #FFF;
        border-color: #D0472F;
        outline: 2px solid #036DCB;
        outline-offset: 2px;
        text-decoration: none;
    }

    &,
    & > span,
    & > span > span {
        white-space: nowrap;
        overflow: visible;
        display: inline-flex;
        align-items: center;
    }
`;
export const StyledSpoeBox = styled(Box) `
  border-radius: 8px !important;
  border: 2px solid ${({ theme }) => theme.palette.primaryDarker};
  max-width: 650px;
  position: relative;
  margin-top: 0;
  z-index: 1;
  padding: 4.5rem 1rem 3rem 1rem;
  h1 {
    line-height: 1.875rem;
    text-align: 'center';
    padding-top: 0 !important;
    margin-top: 0 !important;
    font-family: 'Merriweather', serif;
  }
  form > :nth-child(2) {
    margin-bottom: 1.5rem;
  }
  form {
    margin-left: 2rem;
    margin-right: 2rem;
  }
  form > :first-child {
    margin-bottom: 0.75rem;
  }
  form > :nth-child(2) {
    margin-bottom: 2.5rem;
  }
  button[aria-label='Show Password'] {
    padding: 0 0.25rem;
  }
    form > :is(:first-child, :nth-child(2)) > :first-child{
      border-radius: 0.25rem;
  }
  input {
    padding-top: 0;
    padding-bottom: 0;
  }
  input:-webkit-autofill {
    animation-duration: 1ms;
  }
  @media (max-width: ${MOBILE_SPOE}) {
    border: 0;
    background-color: transparent;
    margin-top: 3.5rem;
    padding: 2rem 0;
    .row > * {
      padding-left: 0;
      padding-right: 0;
    }
    form > :nth-child(2) {
        margin-bottom: 1.5rem;
    }
  }
`;
//TODO -- fix up banner so other later components dont need to offset their margins
export const StyledPageContainer = styled('div') `
  margin-top: -8rem;
  display: flex;
  justify-content: center;
  @media only screen and (max-width: 767px) {
    margin-top: -10rem;
  }
`;
export const HeadingSpoeBanner = () => {
    return (<HeadingSpoeBannerWrapper>
    <BackgroundWave />
  </HeadingSpoeBannerWrapper>);
};
export const HeadingSpoeBannerWrapper = styled('div') `
  padding-bottom: 0;
  margin-bottom: 0;
  width: 100vw;
  aspect-ratio: 1440 / 217;
  z-index: 0;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  display: flex;
  position: absolute;
  bottom: 0;
  left: 0;
  pointer-events: none;
  @media (max-width: ${MOBILE_SPOE}) {
      position: relative;
  }
`;
